function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, memo } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import { useWorkFlow } from "../contexts/workflow";
import Translate from "../common/translation";
import ResponseType from "../input-types";
import { WeverCoreContext, _translate } from "../../services/core";
import QuestionService from "./service";
import QuestionDescription from "./question-description";

/**
 * Contenu centrale de la page, titre, description, "formulaire/inputs"
 */
var QuestionContent = function QuestionContent(props) {
  var content = props.content,
    onChange = props.onChange,
    index = props.index,
    loop = props.loop;
  var _useContext = useContext(WeverCoreContext),
    locale = _useContext.locale;
  var _useWorkFlow = useWorkFlow(),
    collector = _useWorkFlow.collector;
  var currentQuestion = collector.currentQuestion,
    responses = collector.responses;
  var _useState = useState('mb-5'),
    _useState2 = _slicedToArray(_useState, 2),
    styleTitle = _useState2[0],
    setStyleTitle = _useState2[1];
  var hasIndex = index !== false && index !== null && index >= 0;
  var getName = function getName() {
    var name = content.name[locale];
    var valueLoop = content.loop_label || currentQuestion.loop;
    if (!currentQuestion) return null;
    return QuestionService.formatName(name, responses, valueLoop || loop, locale, currentQuestion);
  };
  var loopLabel = parseInt(currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.loop_label);
  var existLoopLabel = !isNaN(loopLabel) && loopLabel >= 0;
  var community = collector.diag ? collector.diag.community : {
    polygon: null,
    polygonColor: null
  };
  if (!(content !== null && content !== void 0 && content.name) || !currentQuestion) return null;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "collectorQuestionName ".concat(styleTitle)
  }, /*#__PURE__*/React.createElement("p", {
    className: "fw-bold fs-12"
  }, getName()), hasIndex && /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Translate, {
    id: "for"
  }), " ", /*#__PURE__*/React.createElement(Translate, {
    id: content.title
  }))), /*#__PURE__*/React.createElement("p", {
    className: "loop_number ".concat(!existLoopLabel && 'd-none')
  }, _translate('collectorapp_deplacementloop_number'), existLoopLabel && /*#__PURE__*/React.createElement(React.Fragment, null, " ", loopLabel + 1)), content.description && content.description[locale] && /*#__PURE__*/React.createElement(QuestionDescription, {
    text: content.description[locale],
    setParentStyle: setStyleTitle
  }), /*#__PURE__*/React.createElement(Row, {
    className: "collectorQuestionResponse"
  }, /*#__PURE__*/React.createElement(Col, {
    className: "col-12 col-response"
  }, /*#__PURE__*/React.createElement(ResponseType, {
    content: content,
    onChange: onChange,
    index: index,
    loop: loop
  }))), /*#__PURE__*/React.createElement("br", null));
};
QuestionContent.propTypes = {
  index: PropTypes.number
};
QuestionContent.defaultProps = {
  index: null
};
export default /*#__PURE__*/memo(QuestionContent);